import axios from 'axios'
import Cookies from 'universal-cookie'

import type { AxiosError, RawAxiosRequestConfig } from 'axios'
import type { IApiError } from '~/types/api'

import { handleGenericError } from './error'

import { COOKIES } from '~/const'

import 'react-toastify/dist/ReactToastify.css'

const cookies = new Cookies()

export const request = async <T>(config: RawAxiosRequestConfig, withAuth = true): Promise<T> => {
  const bearer = cookies.get(COOKIES.TOKENS)?.access_token

  const authorizationHeader: Record<string, string> = withAuth ? { authorization: bearer } : {}

  const headers = {
    headers: {
      ...config.headers,
      ...authorizationHeader,
    },
  }

  if (bearer) {
    const { data } = await axios
      .request<T>({
        method: 'GET',
        ...config,
        ...headers,
      })
      .catch((e: AxiosError<IApiError>) => {
        if (
          e.response?.status !== 400 &&
          e.response?.status !== 403 &&
          e.response?.status !== 404 &&
          e.response?.status !== 409 &&
          e.response?.status !== 422 &&
          e.response?.status !== 425 &&
          e.response?.status !== 501
        ) {
          handleGenericError(e)
        }

        return Promise.reject(e)
      })

    return data
  }

  // NOTE: No access token => redirect to login and reject
  window.location.replace('/')

  return Promise.reject({
    response: {
      data: {
        code: 401,
        context: '',
        message: 'You need to login',
      },
    },
  })
}
